export default __webpack_public_path__ + "static/media/reg_no_overlay.2122d17b.jpg";